export class MobilePivotModel {
  label: string;
  routerLink: any;
}